import formatNumber from './format-number';
import { getTemperatureUnitLabel } from './get-user-units-pref';

export default (temp_f) => {
  const tempUnit = getTemperatureUnitLabel();
  return temp_f === null ? 'N/A' : `${formatNumber(temp_f)}${tempUnit}`;
};
